<template>
    <div role="status" class="animate-pulse">
        <div class="h-12 bg-gray-200 rounded-lg mb-4"></div>
        <div class="h-3 bg-gray-200 rounded-sm max-w-xl mt-7"></div>
        <div class="h-3 bg-gray-200 rounded-sm my-3 max-w-sm"></div>

        <div v-for="n in 3">
            <div class="h-10 bg-gray-200 rounded-sm my-5 max-w-3xl"></div>
            <div v-for="n in 5" class="flex justify-between max-w-3xl pb-3">
                <div class="h-4 bg-gray-200 w-1/2 rounded-lg max-w-44"></div>
                <div class="h-4 bg-gray-200 w-1/2 rounded-lg max-w-44"></div>
            </div>
        </div>

        <div class="flex gap-2 mt-32">
            <div class="h-10 bg-gray-200 w-1/2 rounded-lg max-w-44"></div>
            <div class="h-10 bg-gray-200 w-1/2 rounded-lg max-w-44"></div>
        </div>
    </div>
</template>